import liff from "@line/liff";
import { message } from "antd";
import axios from "axios";
import * as COMMONS from "common/common";

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/api/liff`;

export default class ClientApiBase {
	constructor() {
		this.axios = axios.create({
			withCredentials: true,
			baseURL: BASE_URL,
			timeout: 60000,
		});

		this.axios.interceptors.request.use(
			(config) => {
				const accessToken = liff.getAccessToken();
				config.headers = { "access-token": accessToken };

				if (config.data instanceof FormData) {
					config.headers["Content-Type"] = "multipart/form-data";
				}
				return config;
			},
			(error) => {
				return error;
			},
		);

		this.axios.interceptors.response.use(
			(response) => {
				return Promise.resolve(response.data);
			},
			(error) => {
				switch (error?.response?.status) {
					case COMMONS.RESPONSE_SYSTEM_ERROR:
						message.error({
							content: COMMONS.ERROR_SYSTEM_MSG,
							key: COMMONS.MESSAGE_SYSTEM_ERROR_KEY,
						});
						break;

					case COMMONS.RESPONSE_BAD_REQUEST_ERROR:
						const errorMessage =
							typeof error.response?.data === "string"
								? error.response.data
								: COMMONS.ERROR_400_MSG;

						message.error({
							content: errorMessage,
							key: COMMONS.MESSAGE_BAD_REQUEST_KEY,
						});
						break;

					case COMMONS.RESPONSE_CONFLICT_ERROR: {
						if (typeof error.response?.data === "string") {
							message.error(error.response.data);
						}
						break;
					}

					case COMMONS.RESPONSE_SESSION_ERROR:
						message.error({
							content: COMMONS.ERROR_SESSION_MSG,
							key: COMMONS.MESSAGE_SESSION_ERROR_KEY,
						});
						break;

					case COMMONS.RESPONSE_SERVICE_UNAVAILABLE: {
						const retryAfter =
							error.response?.headers?.["retry-after"];
						message.error({
							content: COMMONS.ERROR_503_MSG(retryAfter),
							key: COMMONS.MESSAGE_SERVICE_UNAVAILABLE_KEY,
						});
						break;
					}

					default:
						break;
				}

				return Promise.reject(error?.response?.data);
			},
		);
	}
}
